module.exports = {"id":"224385","name":"Hiroki Yamada","rating":"71","photo":"./data/images/photos/0/224385.png","club":{"name":"Iwata","logo":"./data/images/clubs/Iwata.png"},"positions":["MG","MOC","MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HirokiYamada0.json
// module id = 1744
// module chunks = 0